<template>
  <div class="login-box">
    <h1 class="title">Confirm Email</h1>
    <p>Enter the verification code you should have recieved via email. Make sure to check your spam folder!</p>
    <b-message type="is-danger" v-if="error">
      {{ error.message }}
    </b-message>
    <b-field label="Email">
      <b-input v-model="username" v-on:keyup.enter="login"></b-input>
    </b-field>

    <b-field label="Code">
      <b-input v-model="code" v-on:keyup.enter="login"> </b-input>
    </b-field>
    <div style="text-align: center">
      <b-button v-on:click="confirm()" type="is-success">Confirm</b-button>
    </div>
    <br />
    <div style="text-align: center">
      <b-button v-on:click="resendCode()" type="is-warning">Resend Code</b-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "Signup",
  data() {
    return {
      username: "",
      code: "",
      error: null,
      loading: false,
    };
  },
  methods: {
    confirm() {
      this.loading = true;
      /*eslint: no-unused-vars: "off"*/
      this.$cognitoAuth.confirmRegistration(this.username, this.code, (err, result) => {
        if (err) {
          this.error = err;
          this.loading = false;
        } else {
          this.$router.push("/");
        }
      });
    },
    resendCode() {
      this.$cognitoAuth.resendConfirmationCode(this.username, (err, result) => {
        if (err) {
          this.error = err;
          this.loading = false;
        } else {
          this.$buefy.snackbar.open({
            message: "A new code has been sent to the email specified!",
            type: "is-success",
            position: "is-top",
          });
        }
      });
    },
  },
  mounted() {
    const urlParams = new URLSearchParams(window.location.search);
    this.username = urlParams.get("email");
    let self = this;

    window.addEventListener("keyup", function (ev) {
      if (ev.key == "Enter") {
        self.confirm();
      }
    });
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.login-box {
  width: 400px;
  height: auto;
  background-color: white;
  border-radius: 5px;
  padding: 25px;
  margin: auto;
  margin-top: 60px;
  border: 1px solid #e4e6e7;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.4);
}
</style>
